import React from 'react';
import './LoadingModal.css';
import logo from '../assets/logo/logo.webp'; // Yerine kendi resmini koy

export default function LoadingModal({ progress }) {
  return (
    <div className="loading-modal">
      <div className="loading-backdrop" />
      <div className="loading-panel">
        <img src={logo} alt="Game Logo" className="loading-pulse-logo" />
        <div className="loading-text">Loading... {Math.floor(progress)}%</div>
        <div className="loading-bar-outer">
          <div className="loading-bar-inner" style={{ width: `${progress}%` }} />
        </div>
      </div>
    </div>
  );
}
